import * as React from 'react'
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl'
import { Elements } from '@tfo/common'
import { inject } from 'mobx-react'
import './IndividualHeader.scss'

const { Heading1, Heading2, Heading6, Paragraph } = Elements
export interface HeadingProps {
	companyName: string
	headingId?: string
	subHeadingId?: string
	headingData?: any
	preambleId?: string
	preambleData?: any
	isBig?: boolean,
	isIDD?: boolean
}

const IndividualHeader: React.FunctionComponent<HeadingProps &
	WrappedComponentProps> = props => {
	return (
		<div className={'IndividualHeader'}>
			<h1 className="IndividualHeader__Heading1">{props.companyName}</h1>
			{props.isBig && props.headingId && (
				<>
					<h2 className="IndividualHeader__Heading1">
						<FormattedMessage
							id={props.headingId || ''}
							values={props.headingData}
						/>
					</h2>
					<h3 className="IndividualHeader__Heading1">
						<FormattedMessage
							id={props.subHeadingId || ''}
							values={props.headingData}
						/>
					</h3>
				</>
			)}
			{props.isBig && props.preambleId && (
				<div className="IndividualHeader__Heading6">
					<Paragraph>
						{
							props.intl.formatMessage({id: props.preambleId || ''}, {companyName: props.preambleData.companyName})
						}
						{!props.isIDD &&
						<b>
							{
								props.intl.formatMessage({id:'startIndividual.body.bold' })
							}
						</b>
						}
					</Paragraph>
				</div>
			)}

			{!props.isBig && props.headingId && (
				<h2 className="IndividualHeader__Heading2">
					<FormattedMessage
						id={props.headingId || ''}
						values={props.headingData}
					/>
				</h2>
			)}
			{!props.isBig && props.preambleId && (
				<div className="IndividualHeader__Paragraph">
					<Paragraph>
						{
							props.intl.formatMessage({id: props.preambleId || ''}, {companyName: props.preambleData.companyName, date: props.preambleData.date, time: props.preambleData.time})
						}
					</Paragraph>
				</div>
			)}
		</div>
	)
}

export default inject('rootStore')(injectIntl(IndividualHeader))
